import React, { useContext, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Header from '../components/Header';
import Message from '../components/LoadingError/Error';
import Loading from '../components/LoadingError/Loading';
import { ResponsiveContext } from '../contexts/ResponsiveContext';
import { createOrder, findPreorder } from '../service/OrdersService';
import { adminColors } from '../constants/constantsValues';

const PlaceOrderScreen = ({ user }) => {
  const [preorder, setPreorder] = useState();
  const [updatedPreorder, setUpdatedPreorder] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [showCustomer, setShowCustomer] = useState(false);
  const [showOrderInfo, setShowOrderInfo] = useState(false);
  const [showDelivery, setShowDelivery] = useState(false);

  const navigate = useNavigate();
  const params = useParams();
  const preorderId = params.id;

  const { is775, is575, is350, is450 } = useContext(ResponsiveContext);

  const addDecimals = (num) => {
    return (Math.round(num * 100) / 100).toFixed(2);
  };

  useEffect(() => {
    if (preorder) {
      const preorderItems = [];
      preorder.cartItems.map((item) => preorderItems.push(item));
      const user = preorder.user;
      const userAddress = preorder.userAddress;
      const deliveryAddress = preorder.deliveryAddress;
      const deliveryMethod = preorder.deliveryMethod;
      const paymentMethod = preorder.paymentMethod;
      const itemsPrice = addDecimals(
        preorderItems?.reduce(
          (acc, item) => acc + (item.price / 1.21) * item.qty,
          0
        )
      );
      const itemsTotalPrice = addDecimals(
        preorderItems?.reduce((acc, item) => acc + item.price * item.qty, 0)
      );
      const shippingPrice =
        preorder.deliveryMethod === 'tienda'
          ? 0
          : addDecimals(itemsPrice > 200 / 1.21 ? 0 : 5.95 / 1.21);
      const taxPrice = addDecimals(
        Number((0.21 * itemsPrice + 0.21 * shippingPrice).toFixed(2))
      );
      const totalPrice =
        preorder.deliveryMethod === 'domicilio'
          ? itemsPrice > 200 / 1.21
            ? Number(itemsTotalPrice).toFixed(2)
            : (Number(itemsTotalPrice) + Number(5.95)).toFixed(2)
          : Number(itemsTotalPrice).toFixed(2);

      setUpdatedPreorder({
        user: user,
        orderItems: preorderItems,
        userAddress: userAddress,
        deliveryAddress: deliveryAddress,
        deliveryMethod: deliveryMethod,
        paymentMethod: paymentMethod,
        itemsPrice: itemsPrice,
        shippingPrice: shippingPrice,
        taxPrice: taxPrice,
        totalPrice: totalPrice,
      });
    }
  }, [preorder]);

  useEffect(() => {
    if (user) {
      findPreorder(preorderId).then((preorder) => {
        setPreorder(preorder[0]);
        setLoading(false);
      });
    }
  }, [user, preorderId]);

  const handleMenu = (e) => {
    if (e === 'showCustomer') {
      setShowOrderInfo(false);
      setShowDelivery(false);
      setShowCustomer((old) => !old);
    }
    if (e === 'showOrderInfo') {
      setShowCustomer(false);
      setShowDelivery(false);
      setShowOrderInfo((old) => !old);
    }
    if (e === 'showDelivery') {
      setShowCustomer(false);
      setShowOrderInfo(false);
      setShowDelivery((old) => !old);
    }
  };

  const placeOrderHandler = () => {
    const order = {
      user: updatedPreorder.user,
      userAddress: updatedPreorder.userAddress,
      deliveryAddress: updatedPreorder.deliveryAddress,
      orderItems: updatedPreorder.orderItems,
      deliveryMethod: updatedPreorder.deliveryMethod,
      paymentMethod: updatedPreorder.paymentMethod,
      taxPrice: updatedPreorder.taxPrice,
      shippingPrice: updatedPreorder.shippingPrice,
      totalPrice: updatedPreorder.totalPrice,
      orderStatus: 'Awaiting payment',
      isPaid: false,
      isDelivered: false,
    };

    createOrder(order, preorderId)
      .then((id) => id && navigate(`/order/${id}`))
      .catch((error) => setError(error.response.data.message));
  };

  return (
    <>
      <Header searcherDisabled={true} shopLink={true} />
      <div className='container'>
        {error && <Message variant='alert-danger'>{error}</Message>}
        {loading ? (
          <Loading />
        ) : (
          <>
            <div
              className={
                !is575
                  ? 'd-flex flex-row justify-content-around mt-5'
                  : 'row order-detail'
              }
            >
              <div className='col-lg-4 col-sm-4 mb-lg-4 mb-5 mb-sm-0'>
                <div className='row '>
                  <div
                    className={`col-md-4 center ${
                      !is775 ? 'd-flex justify-content-center' : ''
                    }`}
                    onClick={() => handleMenu('showCustomer')}
                  >
                    <div className='alert-success order-box'>
                      <i
                        className='fas fa-user'
                        style={{
                          color: showCustomer && !is775 ? 'orange' : 'black',
                        }}
                      ></i>
                    </div>
                  </div>
                  {is775 && (
                    <div className={`${!is775 && 'mt-3'} col-md-8 center`}>
                      <h5>
                        <strong>Cliente</strong>
                      </h5>
                      <p>
                        {preorder?.user.name} {preorder?.user.lastName}
                      </p>
                      <p>{preorder?.user.email}</p>
                      <p>{preorder?.user.phone}</p>
                    </div>
                  )}
                </div>
              </div>
              {/* 2 */}
              <div className='col-lg-4 col-sm-4 mb-lg-4 mb-5 mb-sm-0'>
                <div className='row'>
                  <div
                    className={`col-md-4 center ${
                      !is775 ? 'd-flex justify-content-center' : ''
                    }`}
                    onClick={() => handleMenu('showOrderInfo')}
                  >
                    <div className='alert-success order-box'>
                      <i
                        className='fas fa-truck-moving'
                        style={{
                          color: showOrderInfo && !is775 ? 'orange' : 'black',
                        }}
                      ></i>
                    </div>
                  </div>
                  {is775 && (
                    <div className={`${!is775 && 'mt-3'} col-md-8 center`}>
                      <h5>
                        <strong>Información del Pedido</strong>
                      </h5>
                      <p>
                        {preorder?.deliveryMethod === 'tienda'
                          ? 'Recogida: '
                          : 'Entregar: '}
                        {preorder?.deliveryMethod &&
                        preorder.deliveryMethod === 'domicilio'
                          ? 'Domicilio'
                          : 'Tienda'}
                      </p>
                      <p>
                        Pago:{' '}
                        {preorder?.paymentMethod &&
                        preorder.paymentMethod === 'mano'
                          ? 'En mano'
                          : 'Tarjeta de Crédito'}
                      </p>
                    </div>
                  )}
                </div>
              </div>
              {/* 3 */}
              <div className='col-lg-4 col-sm-4 mb-lg-4 mb-5 mb-sm-0'>
                <div className='row d-flex'>
                  <div
                    className={`col-md-4 center ${
                      !is775 ? 'd-flex justify-content-center' : ''
                    }`}
                    onClick={() => handleMenu('showDelivery')}
                  >
                    <div className='alert-success order-box'>
                      <i
                        className='fas fa-map-marker-alt'
                        style={{
                          color: showDelivery && !is775 ? 'orange' : 'black',
                        }}
                      ></i>
                    </div>
                  </div>
                  {is775 && (
                    <div className={`${!is775 && 'mt-3'} col-md-8 center`}>
                      <h5>
                        <strong>
                          {preorder?.deliveryMethod
                            ? preorder?.deliveryMethod === 'tienda'
                              ? 'Recogida: '
                              : 'Entregar: '
                            : 'Info método de entrega'}
                        </strong>
                      </h5>
                      <p>
                        Dirección:{' '}
                        {preorder?.deliveryMethod
                          ? preorder?.deliveryMethod === 'tienda'
                            ? 'C. de Virgen de Lluc, 4, 28027, Madrid'
                            : `${preorder?.deliveryAddress?.address}, ${preorder?.deliveryAddress?.flat}, ${preorder?.deliveryAddress?.postalCode}, ${preorder?.deliveryAddress?.city}  `
                          : 'Sin definir'}{' '}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {!is775 && (
              <div className={is350 ? 'mx-5' : 'mx-1'}>
                {showCustomer && (
                  <div>
                    <h6>
                      <strong>Cliente</strong>
                    </h6>
                    <p>{preorder?.user.email}</p>
                    <p>{preorder?.user.phone}</p>
                  </div>
                )}
                {showOrderInfo && (
                  <div>
                    <h6>
                      <strong>Información del Pedido</strong>
                    </h6>
                    <p>
                      {preorder?.deliveryMethod === 'tienda'
                        ? 'Recogida'
                        : 'Envío'}{' '}
                      : {preorder?.deliveryMethod}
                    </p>
                    <p>
                      {preorder?.paymentMethod === 'mano'
                        ? 'Pago en tienda'
                        : ''}
                    </p>
                  </div>
                )}
                {showDelivery && (
                  <div>
                    <h6>
                      <strong>
                        {preorder?.deliveryMethod === 'tienda'
                          ? 'Recogida: '
                          : 'Entregar: '}
                      </strong>
                    </h6>
                    <p>
                      Dirección:{' '}
                      {preorder?.deliveryMethod
                        ? preorder?.deliveryMethod === 'tienda'
                          ? 'C. de Virgen de Lluc, 4, 28027, Madrid'
                          : `${preorder?.deliveryAddress?.address}, ${preorder?.deliveryAddress?.flat}, ${preorder?.deliveryAddress?.postalCode}, ${preorder?.deliveryAddress?.city}  `
                        : 'Sin definir'}{' '}
                    </p>
                  </div>
                )}
              </div>
            )}

            <div className='row order-products justify-content-between'>
              <div className='col-lg-8'>
                {updatedPreorder?.orderItems?.length === 0 ? (
                  <Message variant='alert-info mt-5'>
                    Tu carrito está vacío
                  </Message>
                ) : (
                  <>
                    {updatedPreorder?.orderItems?.map((item, index) => (
                      <div className='order-product row' key={index}>
                        <div className='col-md-3 col-6'>
                          <img src={item.image} alt={item.name} />
                        </div>
                        <div className='col-md-4 col-6 d-flex align-items-center'>
                          <Link to={`/products/${item.productId}`}>
                            <h6>{item.name}</h6>
                          </Link>
                        </div>
                        <div className='mt-3 mt-md-0 col-md-3 col-6 d-flex flex-row align-items-center justify-content-around '>
                          <div className='d-flex flex-row align-items-center'>
                            {is450 ||
                              (is775 && <h4 className='mb-0 fs-4 me-1'>T:</h4>)}
                            <h6 className='fs-5'>{item.size}</h6>
                          </div>
                          <div className='d-flex flex-row align-items-center'>
                            {is450 ||
                              (is775 && <h4 className='mb-0 fs-4 me-1'>C:</h4>)}
                            <div
                              className='mx-1 mb-1 d-flex align-items-center'
                              style={{
                                width: '20px',
                                height: '20px',
                                backgroundColor: `${
                                  adminColors.filter(
                                    (el) => el.name === item.color
                                  )[0]?.color
                                }`,
                                border: '1px solid black',
                                borderRadius: '50%',
                                cursor: 'pointer',
                              }}
                              key={item.color}
                            ></div>
                          </div>
                          <div className='d-flex flex-row align-items-center'>
                            <h6 className='fs-5'>{item.qty} Uds</h6>
                          </div>
                        </div>

                        <div className='mt-3 mt-md-0 col-md-2 col-6 align-items-end  d-flex flex-column justify-content-center '>
                          {/* <h4>SUBTOTAL</h4> */}
                          <h6>
                            {(item.qty * item.price)
                              .toString()
                              .replace('.', ',')}
                            {(item.qty * item.price)
                              .toString()
                              .replace('.', ',')
                              .split(',')[1]
                              ? (item.qty * item.price)
                                  .toString()
                                  .replace('.', ',')
                                  .split(',')[1].length === 1
                                ? '0'
                                : ''
                              : ',00'}{' '}
                            €
                          </h6>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
              {/* total */}
              <div className='col-lg-3 d-flex align-items-end flex-column mt-5 subtotal-order'>
                <table className='table table-bordered'>
                  <tbody>
                    <tr>
                      <td>
                        <strong>Productos</strong>
                      </td>
                      <td className='d-flex justify-content-end'>
                        {updatedPreorder?.itemsPrice
                          .toString()
                          .replace('.', ',')}
                        {updatedPreorder?.itemsPrice
                          .toString()
                          .replace('.', ',')
                          .split(',')[1]
                          ? updatedPreorder?.itemsPrice
                              .toString()
                              .replace('.', ',')
                              .split(',')[1].length === 1
                            ? '0'
                            : ''
                          : ',00'}{' '}
                        €
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Envío</strong>
                      </td>
                      <td className='d-flex justify-content-end'>
                        {updatedPreorder?.shippingPrice
                          .toString()
                          .replace('.', ',')}
                        {updatedPreorder?.shippingPrice
                          .toString()
                          .replace('.', ',')
                          .split(',')[1]
                          ? updatedPreorder?.shippingPrice
                              .toString()
                              .replace('.', ',')
                              .split(',')[1].length === 1
                            ? '0'
                            : ''
                          : ',00'}{' '}
                        €
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>IVA</strong>
                      </td>
                      <td className='d-flex justify-content-end'>
                        {(updatedPreorder?.taxPrice)
                          .toString()
                          .replace('.', ',')}
                        {updatedPreorder?.taxPrice
                          .toString()
                          .replace('.', ',')
                          .split(',')[1]
                          ? updatedPreorder?.taxPrice
                              .toString()
                              .replace('.', ',')
                              .split(',')[1].length === 1
                            ? '0'
                            : ''
                          : ',00'}{' '}
                        €
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Total</strong>
                      </td>
                      <td className='d-flex justify-content-end'>
                        {updatedPreorder?.totalPrice
                          .toString()
                          .replace('.', ',')}
                        {updatedPreorder?.totalPrice
                          .toString()
                          .replace('.', ',')
                          .split(',')[1]
                          ? updatedPreorder?.totalPrice
                              .toString()
                              .replace('.', ',')
                              .split(',')[1].length === 1
                            ? '0'
                            : ''
                          : ',00'}{' '}
                        €
                      </td>
                    </tr>
                  </tbody>
                </table>
                {updatedPreorder?.updatedPreorder?.orderItems?.length ===
                0 ? null : (
                  <button type='submit' onClick={placeOrderHandler}>
                    REALIZAR PEDIDO
                  </button>
                )}
                {error && (
                  <div className='my-3 col-12'>
                    <Message variant='alert-danger'>{error}</Message>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PlaceOrderScreen;
